import { NgModule, APP_INITIALIZER, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { ModalsModule } from './_stealth/partials';
import { MaterialsModule } from './modules/materials/materials.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MSAL_INSTANCE, MsalService } from '@azure/msal-angular';
import { AuthService } from './modules/account';
import { MsalInstanceFactory } from './modules/account/factory/msal-factory';
import { DataEncryptionService } from './modules/account/services/data-encryption.service';
import { DirectivesModule } from './modules/account/services/directives/directives.module';
import { AuthInterceptor } from './modules/account/services/interceptors/auth.interceptor';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ErrorInterceptor } from './modules/core/interceptors/error.interceptor';
import { UpdateConfirmationDialog } from './pages/main/stealth-pulse/application-catalog-v3/update-confirmation-dialog/update-confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';



function appInitializer(authService: AuthService) {
  return () => {
    let params = new URLSearchParams(document.location.search.replace("?", ''));
    let impersonationToken = params.get('impersonationToken');
    if (impersonationToken) {
      return new Promise((resolve) => {
        authService.currentTenantIdValue = params.get('tenantId') as number | null;
        authService.impersonatedLogin(impersonationToken as string).subscribe(resolve);
      });
    } else {
      return new Promise((resolve) => {
        //@ts-ignore
        authService.getCurrentUser().subscribe(resolve);
      });
    }
  };
}

export function getCurrentLanguage(): string {
  return 'en-us';
}

@NgModule({
  declarations: [
    AppComponent,
    UpdateConfirmationDialog
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    ClipboardModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    DirectivesModule,
    MatDialogModule,
    ModalsModule,
    MaterialsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      extendedTimeOut: 1000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useFactory: getCurrentLanguage
    },
    DataEncryptionService,
    {
      provide: MSAL_INSTANCE,
      useFactory: MsalInstanceFactory
    },
    MsalService,
    DatePipe,
    importProvidersFrom(
      OktaAuthModule.forRoot({
        oktaAuth: new OktaAuth({
          issuer: 'https://garda.okta.com',
          clientId: environment.okta.clientId,
          redirectUri: `${window.location.origin}/sso/login`,
          scopes: ['openid', 'profile', 'email'],
        })
      })
    ),
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
